import moment from "moment-timezone";

export const DEFAULT_TIMEZONE = "UTC";

export const getBrowserTimezone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone || DEFAULT_TIMEZONE;

export const getEffectiveTimezone = (
  timezone?: string | null,
  fallbackTimezone?: string | null
) => {
  if (timezone && moment.tz.zone(timezone)) {
    return timezone;
  }

  if (fallbackTimezone && moment.tz.zone(fallbackTimezone)) {
    return fallbackTimezone;
  }

  const browserTimezone = getBrowserTimezone();

  if (moment.tz.zone(browserTimezone)) {
    return browserTimezone;
  }

  return DEFAULT_TIMEZONE;
};

export const getIanaTimezones = () => moment.tz.names();

export const getTimestampForTimezone = (
  date: Date,
  time: string,
  timezone?: string | null
) => {
  const safeTimezone = getEffectiveTimezone(timezone);
  const datePart = moment(date).format("YYYY-MM-DD");

  return moment
    .tz(`${datePart} ${time}`, "YYYY-MM-DD HH:mm", safeTimezone)
    .unix();
};

export const getDatePickerValueInTimezone = (
  inputDate: string,
  timezone?: string | null
) => {
  const zonedDate = moment.tz(inputDate, getEffectiveTimezone(timezone));

  return new Date(zonedDate.year(), zonedDate.month(), zonedDate.date());
};

export const getTimeInputValueInTimezone = (
  inputDate: string,
  timezone?: string | null
) => moment.tz(inputDate, getEffectiveTimezone(timezone)).format("HH:mm");
